/**
 * The single Pixi canvas, registered once at boot, so DOM-overlay widgets (TextArea) can map their
 * design-space position to viewport pixels via the canvas bounding rect. Mirrors the setUiIcons /
 * setBackgroundTexture module-registry pattern.
 */
let overlayCanvas: HTMLCanvasElement | null = null;

export function setOverlayCanvas(canvas: HTMLCanvasElement | null): void {
  overlayCanvas = canvas;
}

export function getOverlayCanvas(): HTMLCanvasElement | null {
  return overlayCanvas;
}
